module.exports = __webpack_public_path__ + "img/2_238.180bc5b6.png";